import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const supportedLanguages = ["en", "fr"];

const initi18nRuntime = () => {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      detection: {
        order: [ 'htmlTag']
      },
      // debug: true,
      fallbackLng: "fr",
      resources: {
        en: {
          translation: require("../locales/en/translation.json"),
        },
        fr: {
          translation: require("../locales/fr/translation.json"),
        },
      },
      supportedLngs: supportedLanguages
    })
}

initi18nRuntime()
